/* import __COLOCATED_TEMPLATE__ from './upsell.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
import { GetKybVerificationDataRequest } from '@square/dashboard-protos/models/squareup/bbqualifier/verification_data_service';
import { VerificationStatus } from '@square/dashboard-protos/models/squareup/bbqualifier/verification_service';
import { CHECKING_BANNER_VARIANT } from '@banking/ui/utils/constants';
import { getCheckingUpsellImage, getOnboardingUpsellImageUrl } from '@banking/ui/utils/checking-image-urls';
let Upsell = (_class = class Upsell extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "bbQualifierApi", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor6, this);
    _defineProperty(this, "productName", void 0);
    _initializerDefineProperty(this, "isApprovedForChecking", _descriptor7, this);
    _initializerDefineProperty(this, "isLoading", _descriptor8, this);
    try {
      const country = Country[this.userInfo.countryCode];
      if (!(country === Country.US || country === Country.CA || country === Country.GB)) {
        throw new Error(`Country "${country}" is not supported within stored balance routes.`);
      }
      if (this.storedBalanceProductPositioning.productName === ProductName.None) {
        throw new Error('ProductName.None is not supported within stored balance routes.');
      }
      this.productName = this.storedBalanceProductPositioning.productName;
    } catch (error) {
      this.sentry.captureException(error);
      throw error;
    }
    this.setIsApprovedForChecking();
  }
  async setIsApprovedForChecking() {
    try {
      const kybVerificationData = await this.bbQualifierApi.getKybVerificationData(GetKybVerificationDataRequest.create({
        unitToken: this.args.unitToken
      }));
      this.isApprovedForChecking = kybVerificationData.kybStatus === VerificationStatus.PASSED;
    } catch {
      throw new Error('getKybVerificationData failed for checking upsell');
    } finally {
      this.isLoading = false;
    }
  }
  get headline() {
    return this.isApprovedForChecking ? this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.approvedHeadline')) : this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.headline'));
  }
  get imageSrc() {
    const countryCode = this.userInfo.countryCode;
    const imgSrc = this.isApprovedForChecking ? getCheckingUpsellImage(countryCode, CHECKING_BANNER_VARIANT.MEDIUM) : getOnboardingUpsellImageUrl(countryCode);
    return this.assetMap.resolve(imgSrc);
  }
  get imageAlt() {
    return this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.imageAlt'));
  }
  get title() {
    return this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.title'), {
      htmlSafe: true
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bbQualifierApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isApprovedForChecking", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
})), _class);
export { Upsell as default };